import React from 'react';
import { TransportDetailsWarning } from './TransportDetailsWarning';
import { TransportDetailsTravelSection } from './TransportDetailsTravelSection';
type TransportDetailsTravelSectionsProps = {
  hasRefNumberEnabled?: boolean;
  onClickCopy?: () => void;
  transportDetailEnriched: TransportDetailEnriched;
};
export function TransportDetailsTravelSections({
  hasRefNumberEnabled = false,
  onClickCopy,
  transportDetailEnriched,
}: TransportDetailsTravelSectionsProps) {
  const travelSections = (transportDetailEnriched.travelSections || []).map(
    (travelSection, index) => (
      <TransportDetailsTravelSection
        firstDeparture={transportDetailEnriched.departure}
        hasRefNumberEnabled={hasRefNumberEnabled}
        key={`TransportDetailsTravelSection-${index * 2}`}
        onClickCopy={onClickCopy}
        travelSection={travelSection}
      />
    ),
  );
  return (
    <div data-testid="TransportDetailsTravelSections" className="bg-lightSand p-20">
      {travelSections}
      <TransportDetailsWarning transportDetailEnriched={transportDetailEnriched} />
    </div>
  );
}
